import * as React from 'react';
import Button from '@mui/material/Button';
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react'
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { postResetPassword } from '../../Redux/actions';
import AlertDialog from '../Common/AlertDialog';
import GreenvironmentLogo from '../../../src/Images/GreenvironmentLogo.svg'
import { useParams } from 'react-router-dom';
import { tokenValidation } from '../../Redux/actions';
import AuthHero from './AuthHero';
import { authGradientButtonSx } from '../../theme/formStyles';
import { CircularProgress } from '@mui/material';
import './Login.css';

export default function ResetPassword() {

  const initForm = {
    password: '',
    confirm: '',
  };
  const navigate = useNavigate()
  const currentUrl = window.location.href;
  const resetPasswordToken = currentUrl.split('/').pop();
  const dispatch = useDispatch();
  const initErr = {};
  const [form, setForm] = useState(initForm);
  const [errors, setErrors] = useState(initErr);
  const [alertMessage, setAlertMessage] = useState();
  const [passReg, setPassReg] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [userTokenStatus, setUserTokenStatus] = useState(true);
  const [msgType, setMsgType] = useState("success");
  const [showLoader, setShowLoader] = useState(true);
  let { token: token } = useParams()

  const state = useSelector(st => st)
    const { user } = state;

  const handleChange = (e) => {
    const { value, name } = e.target;
    const fieldValue = Object.assign({}, form);
    const errorField = Object.assign({}, errors);
    if (errorField[name]) {
      errorField[name] = null;
      setErrors(errorField);
    }
    fieldValue[name] = value;
    setPassReg(false);
    setForm(fieldValue);
  };

  const passwordValidator = (password) => {
    const pattern = new RegExp(/^(?=.*[a-z]+)(?=.*[A-Z]+)(?=.*[0-9]+)(?=.*[!@#$%^&*]).{8,20}$/);
    return pattern.test(password);
  }

  useEffect(() => {
    setShowLoader(true)
    dispatch(tokenValidation(token)).then((res) => {
      if (!res.data.success) {
        setAlertMessage(res.data.message);
        if(localStorage.getItem('accessToken')) {
          navigate('/')
        } else {
          setUserTokenStatus(false);
          setMsgType("fail");
        }
      }
      if(user?.data?.success && (res?.data?.uniqueId !== user?.data?.user?.uniqueId)) {
        navigate('/')
      }

    });
    setShowLoader(false);
  }, [ user, navigate, token])

  const validateData = () => {
    let hasError = false;
    const err = Object.assign({}, errors);
    if (form.password !== form.confirm) {
      hasError = true;
      err.confirm = "New Password and confirm password must be same."
    }

    if (!passwordValidator(form.password)) {
      hasError = true;
      setPassReg(true);
      err.password = `Password doesn't meet the requirements`;
    }

    Object.keys(form).forEach((key) => {
      if (!form[key]) {
        hasError = true;
        err[key] = 'This field is mandatory';
      }
    });
    if (hasError) {
      setErrors(err);
      return false;
    }
    return form;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const valid = validateData();
    if (valid) {
      valid.token = resetPasswordToken;
      dispatch(postResetPassword(valid)).then((resp) => {
        const res = resp && resp.data;
        if (res && res.success) {
          localStorage.removeItem('accessToken');
          setAlertMessage('Password reset successfully. Login now...!')
          setMsgType("success");
        } else if (res && !res.success) {
          setErrors(res.data);
          setAlertMessage(res.message)
          setMsgType("fail");
        }
      });
    }
  }

  const handleCloseDialog = () => {
    setAlertMessage(null);
    navigate('/login')
  }

  if (showLoader) {
    return (
      <div className="gv-login-page">
        <AuthHero />
        <div className="gv-login-panel">
          <div className="gv-login-card" style={{ display: 'flex', justifyContent: 'center', padding: '60px 30px' }}>
            <CircularProgress sx={{ color: '#008080' }} />
          </div>
        </div>
      </div>
    );
  } else if (!userTokenStatus) {
    return (
      <div className="gv-login-page">
        <AuthHero />
        <div className="gv-login-panel">
          <div className="gv-login-card">
            <div className="gv-login-card-logo">
              <img alt="Greenvironment" src={GreenvironmentLogo} />
            </div>
            <div className="gv-login-heading">Reset password request expired</div>
            <div className="gv-login-card-message">
              Your reset password request link has expired, please send a new request to reset your password.
            </div>
            <div className="gv-login-footer-link" style={{ marginTop: 24 }}>
              <Link className="gv-login-forgot-link" to="/forgot-password">Request a new link</Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="gv-login-page">
      <AuthHero />

      <div className="gv-login-panel">
        <div className="gv-login-card">
          <div className="gv-login-card-logo">
            <img alt="Greenvironment" src={GreenvironmentLogo} />
          </div>
          <div className="gv-login-heading">Reset password</div>
          <div className="gv-login-subheading">Choose a new password for your account</div>

          <form noValidate onSubmit={handleSubmit}>
            <div className="gv-login-field-row">
              <label className="gv-login-label" htmlFor="password">New Password</label>
            </div>
            <div className="gv-login-input-wrap">
              <span className="gv-login-input-ico"><LockOutlinedIcon fontSize="small" /></span>
              <input
                id="password"
                className="gv-login-input"
                name="password"
                placeholder="Enter new password"
                onChange={handleChange}
                type={showPassword ? 'text' : 'password'}
                style={{ paddingRight: 40 }}
              />
              <IconButton size='small' className="gv-login-pw-toggle" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
              </IconButton>
            </div>
            {errors.password && <div className="gv-login-error">{errors.password}</div>}
            {
              passReg === true &&
              <ul className="gv-login-pw-rules">
                <li>Minimum password length 8</li>
                <li>Maximum password length 20</li>
                <li>Required at least one digit</li>
                <li>Required at least one upper case</li>
                <li>Required at least one lower case</li>
                <li>Required at least one symbol</li>
              </ul>
            }

            <div className="gv-login-field-row">
              <label className="gv-login-label" htmlFor="confirm">Confirm Password</label>
            </div>
            <div className="gv-login-input-wrap">
              <span className="gv-login-input-ico"><LockOutlinedIcon fontSize="small" /></span>
              <input
                id="confirm"
                className="gv-login-input"
                name="confirm"
                placeholder="Confirm new password"
                onChange={handleChange}
                type={showPasswordConfirm ? 'text' : 'password'}
                style={{ paddingRight: 40 }}
              />
              <IconButton size='small' className="gv-login-pw-toggle" onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}>
                {showPasswordConfirm ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
              </IconButton>
            </div>
            {errors.confirm && <div className="gv-login-error">{errors.confirm}</div>}

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={authGradientButtonSx}
            >
              Reset Password
            </Button>
          </form>

          <div className="gv-login-footer-link">
            <Link className="gv-login-forgot-link" to="/login">Back to Login</Link>
          </div>
        </div>
      </div>

      {alertMessage
        ? (
          <AlertDialog
            handleClose={handleCloseDialog}
            type={msgType}
            message={alertMessage}
            handleDialogClose={() => setAlertMessage(null)}
          />
        ) : null}
    </div>
  );
}
